'use client';

import Image from 'next/image';

import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './background-block-view.css';

import type { BackgroundBlockViewModel } from '../../view-models/blocks/background-block.viewModel';

export function BackgroundBlockView({ hide, fieldImage }: BackgroundBlockViewModel) {
  return hide ? null : (
    <CMSBlockWrapper>
      <div className={css.backgroundBlock}>
        {fieldImage && (
          <Image
            src={fieldImage.uri.value || ''}
            alt={fieldImage?.meta?.alt || ''}
            title={fieldImage?.meta?.title || ''}
            width={1920}
            height={700}
          />
        )}
      </div>
    </CMSBlockWrapper>
  );
}
